import React from "react";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { ButtonGroup, Button, Jumbotron } from "reactstrap";

export const ChangeLanguage = () => {
  const { t } = useTranslation("admin");

  const onSelect = (lng: any) => {
    i18next.changeLanguage(lng);
  };

  return (
    <React.Fragment>
      <Jumbotron
        style={{
          backgroundColor: "white",
          border: "1px solid rgba(0, 0, 0, 0.125)"
        }}
      >
        <ButtonGroup>
          <Button className="sypal-button" onClick={() => onSelect("cs")}>
            Česky
          </Button>
          <Button className="sypal-button" onClick={() => onSelect("en")}>
            English
          </Button>
        </ButtonGroup>
        <br />
        <br />
        <p>{t("Info")}</p>
      </Jumbotron>
    </React.Fragment>
  );
};
